import { usePrivacy } from "contexts/privacy";
import React from "react";
import {
  formatAmount as updatedFormatAmount,
  maskPrivacyAmount,
} from "utils/utils";

export const DisplayAmount = ({ value, format = false, className = "" }) => {
  const { privacyOn } = usePrivacy();

  if (privacyOn) {
    return maskPrivacyAmount(value);
  }
  const formatAmount = (value = 0) => {
    if (!value && value !== 0) return "";
    return new Intl.NumberFormat("en-IN").format(Number(value).toFixed());
  };

  if (format) {
    return <span className={className}>{updatedFormatAmount(value)}</span>;
  }

  return <span className={className}>{formatAmount(value)}</span>;
};
